<template>
  <transition name="message-fade">
    <div v-if="visible" class="message" :class="type">
      <div class="message-content">
        <i v-if="icon" :class="icon"></i>
        <span>{{ message }}</span>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Message',
  data() {
    return {
      visible: false,
      message: '',
      type: 'info',
      duration: 2000,
      timer: null,
      icon: ''
    }
  },
  mounted() {
    this.startTimer()
  },
  methods: {
    startTimer() {
      if (this.duration > 0) {
        this.timer = setTimeout(() => {
          this.close()
        }, this.duration)
      }
    },
    close() {
      this.visible = false
      if (this.timer) {
        clearTimeout(this.timer)
      }
      if (this.$el) {
        this.$el.addEventListener('transitionend', this.destroyElement)
      }
    },
    destroyElement() {
      if (this.$el) {
        this.$el.removeEventListener('transitionend', this.destroyElement)
      }
      this.$destroy()
      if (this.$el && this.$el.parentNode) {
        this.$el.parentNode.removeChild(this.$el)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.message {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  padding: 12px 20px;
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.8);
  color: #fff;
  font-size: 14px;
  line-height: 1.5;
  text-align: center;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  min-width: 200px;
  max-width: 80%;

  .message-content {
    display: flex;
    align-items: center;
    justify-content: center;

    i {
      margin-right: 8px;
      font-size: 16px;
    }
  }

  &.success {
    .message-content i {
      color: #67c23a;
    }
  }

  &.error {
    .message-content i {
      color: #f56c6c;
    }
  }

  &.warning {
    .message-content i {
      color: #e6a23c;
    }
  }
}

.message-fade-enter-active,
.message-fade-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}

.message-fade-enter,
.message-fade-leave-to {
  opacity: 0;
  transform: translate(-50%, -50%) scale(0.9);
}
</style> 